import React, { useState } from "react";
import { modalBoxStyle } from "./styles";
import {
  Button,
  Typography,
  Box,
  Modal,
  CircularProgress,
} from "@mui/material";
import RemoveShoppingCartOutlinedIcon from "@mui/icons-material/RemoveShoppingCartOutlined";

const ClearCartModal = ({ clearCart, isOpen, itemCount, toggleModalOpen }) => {
  const [loading, toggleLoading] = useState(false);

  const closeModal = () => {
    toggleModalOpen();
  };

  const handleClear = async () => {
    try {
      toggleLoading(true);
      await clearCart();
      toggleLoading(false);
      toggleModalOpen();
    } catch (err) {
      console.log(err);
      toggleLoading(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalBoxStyle}>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <Box>
            <Box
              sx={{
                marginBottom: "1rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <RemoveShoppingCartOutlinedIcon sx={{ fontSize: "60px" }} />
            </Box>
            <Box
              sx={{
                marginBottom: "1rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography variant="h2">Clear Cart</Typography>
            </Box>
            <Box
              sx={{
                marginBottom: "1rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="body1" sx={{ textAlign: "center" }}>
                Are you sure you want to remove{" "}
                {itemCount === 1 ? "the 1 item" : `all ${itemCount} items`} from
                your cart? This cannot be undone.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                sx={{ borderRadius: 2 }}
                variant="outlined"
                onClick={closeModal}
              >
                <Typography variant="smallButton">No, Cancel</Typography>
              </Button>
              <Button
                variant="contained"
                type="submit"
                sx={{ borderRadius: 2, marginLeft: 2 }}
                onClick={handleClear}
              >
                <Typography variant="smallButton">Yes, Clear Cart</Typography>
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default ClearCartModal;
